<template>
    <div class="legislation-chart mt-3">
        <div class="chart-header">
            <h4 class="chart-title">Legislación Aplicable</h4>
        </div>
        <div class="card">
            <div v-if="localLoading" class="chart-overlay">
                <div class="spinner">
                    <div class="spinner-border spinner-border-sm text-primary" role="status">
                        <span class="sr-only">Cargando...</span>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="chart-container">
                    <div ref="chart" style="height: 320px; width: 100%;"></div>
                </div>
                <div class="mt-0">
                    <div class="status-item success-item">
                        <div class="status-header">
                            <div class="dot bg-success"></div>
                            <span class="status-text">
                                Cumplen: {{ chartData.characterized }} PQ ({{ chartData.characterizedPercentage }}%)
                            </span>
                            <div class="info-icon">
                                <i class="fa fa-info-circle btn info-btn cursor-pointer" aria-hidden="true" @click="fetchProducts({
                                data: {
                                    key: 'cumply_review',
                                    title: 'Documentos en Cumplimiento'
                                }
                            })"></i>
                            </div>
                        </div>
                         <div class="status-header">
                            <div class="dot"></div>
                            <span>
                                {{ chartData.customLabels.cnp || 'Certificados no peligrosidad' }}: 
                                <span class="status-text">{{ chartData.certificateNotRisk }}</span>
                            </span>                           
                        </div>
                        <div class="fds-progress mt-3" v-if="showReviewSection">
                            <div class="fds-label">Revisión de {{ chartData.customLabels.fds || 'FDS' }}:</div>

                            <div class="progress">
                                <div class="progress-bar bg-fds" :style="reviewedStyle">
                                    {{ (reviewedPercentage == 0 ? '' : reviewedPercentage) + (reviewedPercentage == 0 ?
                                        '' : '%') }}
                                </div>
                                <div class="progress-bar bg-success1" :style="notReviewedStyle">
                                    {{ (notReviewedPercentage == 0 ? '' : notReviewedPercentage) +
                                        (notReviewedPercentage == 0 ? '' : '%') }}
                                </div>
                            </div>
                        </div>
                        <div class="status-details" v-if="showReviewSection">
                            <div class="detail-item">
                                <div class="dot bg-success"></div>
                                <span>Con revisión menor a 5 años: <span class="status-text">{{
                                    chartData.fdsWithReviewed }} PQ</span></span>
                            </div>
                            <div class="detail-item">
                                <div class="dot bg-success1"></div>
                                <span>Por revisar última versión del fabricante: <span class="status-text">{{
                                    chartData.fdsNotReviewed }} PQ</span></span>
                            </div>
                        </div>
                    </div>

                    <div class="status-item warning-item">
                        <div class="status-header">
                            <div class="dot bg-warning-1"></div>
                            <span class="status-text">
                                No cumple: {{ chartData.nonCompliant }} PQ ({{ chartData.nonCompliantPercentage }}%)
                            </span>
                            <div class="info-icon">
                                <i class="fa fa-info-circle btn info-btn cursor-pointer" aria-hidden="true" @click="fetchProducts({
                                data: {
                                    key: 'not_cumply',
                                    title: 'No cumplen'
                                }
                            })"></i>
                            </div>
                        </div>
                    </div>

                    <div class="status-item danger-item">
                        <div class="status-header">
                            <div class="dot bg-danger-1"></div>
                            <span class="status-text">
                                Sin documento: {{ chartData.noDocument }} PQ ({{ chartData.noDocumentPercentage }}%)
                            </span>
                            <div class="info-icon">
                                <i class="fa fa-info-circle btn info-btn cursor-pointer" aria-hidden="true" @click="fetchProducts({
                                data: {
                                    key: 'not_document_legislation',
                                    title: 'Sin documento'
                                }
                            })"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ProductListModal :modal-id="'products-modal-legislation'" :title="modalTitle" :products="selectedProducts"
            :keyProduct="keyProducts" :showReviewSection="showReviewSection" />
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import * as echarts from 'echarts'
import ProductListModal from '../../components/ProductListModal.vue';

export default {
    components: {
        ProductListModal
    },
    name: 'LegislationChart',
    props: {
        data: {
            type: Object,
            required: true,
            default: () => ({
                characterized: 0,
                nonCompliant: 0,
                noDocument: 0,
                fdsWithReviewed: 0,
                fdsNotReviewed: 0,
                notCaracterizedWithCumply: 0,
                totalInventory: 0,
                customLabels: {}
            })
        },
        showReviewSection: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            chart: null,
            modalTitle: '',
            keyProducts: '',
            selectedProducts: [],
            isLoadingChartInfo: {},
            localLoading: false
        }
    },
    computed: {
        ...mapState("dashboard", ["productsDashAffected", "dashboardFilters"]),
        chartData() {
            const total = this.data.totalInventory;
            const safeTotalInventory = total > 0 ? total : 1;
            return {
                characterized: this.data.characterized,
                certificateNotRisk: this.data.certificate_not_risk || 0,
                nonCompliant: this.data.nonCompliant,
                characterizedPercentage: ((this.data.characterized / safeTotalInventory) * 100).toFixed(2),
                nonCompliantPercentage: ((this.data.nonCompliant / safeTotalInventory) * 100).toFixed(2),
                noDocumentPercentage: ((this.data.noDocument / safeTotalInventory) * 100).toFixed(2),
                fdsWithReviewed: this.data.fdsWithReviewed,
                fdsNotReviewed: this.data.fdsNotReviewed,
                noDocument: this.data.noDocument,
                customLabels: this.data.customLabels || {}
            }
        },
        chartOption() {
            const totalInventory = this.data.totalInventory;
            
            const data = [
                {
                    value: this.chartData.characterized,
                    name: 'Cumplen',
                    itemStyle: { color: '#35C895' },
                    label: {
                        show: true,
                        backgroundColor: 'rgba(40, 167, 69, 0.1)',
                        borderColor: '#35C895'
                    },
                    key: 'cumply',
                    title: 'Cumplen'
                },
                {
                    value: this.chartData.nonCompliant,
                    name: 'No cumple',
                    itemStyle: { color: '#F27833' },
                    label: {
                        show: true,
                        backgroundColor: 'rgba(255, 193, 7, 0.1)',
                        borderColor: '#F27833'
                    },
                    key: 'not_cumply',
                    title: 'No cumplen'
                },
                {
                    value: this.chartData.noDocument,
                    name: 'Sin documento',
                    itemStyle: { color: '#F24633' },
                    label: {
                        show: true,
                        backgroundColor: 'rgba(220, 53, 69, 0.1)',
                        borderColor: '#F24633'
                    },
                    key: 'not_document_legislation',
                    title: 'Sin documento'
                }
            ];
            return {
                tooltip: {
                    trigger: 'item',
                    textStyle: {
                        fontFamily: 'Poppins'
                    }
                },
                legend: {
                    show: false
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '80%'],
                        avoidLabelOverlap: true,
                        startAngle: 90,
                        minAngle: 1,
                        label: {
                            show: true,
                            position: 'outside',
                            formatter: (params) => {
                            // Calcula el % usando totalInventory
                            const percentage = ((params.value / totalInventory) * 100);
                            // Formatea a 2 decimales para coincidir con tu cálculo externo
                            return percentage.toFixed(2) + '%';
                            },
                            padding: [2, 2],
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            borderWidth: 1,
                            borderRadius: 4,
                            fontSize: 14,
                            fontWeight: 'bold',
                            rich: {
                                value: {
                                    fontSize: 14,
                                    fontWeight: 'bold',
                                }
                            },
                            bleedMargin: 10, // Aumentado para permitir que las etiquetas salgan del contenedor
                            minMargin: 10 // Margen mínimo entre etiquetas
                        },
                        labelLayout: {
                            draggable: false, // Desactiva el arrastre de etiquetas
                            hideOverlap: false // No oculta etiquetas solapadas
                        },
                        labelLine: {
                            show: true,
                            lineStyle: {
                                width: 2,
                                type: 'solid'
                            }
                        },
                        itemStyle: {
                            borderRadius: 4,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        zlevel: 1,
                        clockwise: true,
                        animation: true,
                        animationDuration: 1000,
                        emphasis: {
                            scale: false,
                            scaleSize: 10,
                            focus: 'none'
                        },
                        data: data.sort((a, b) => b.value - a.value)
                    }
                ]
            }
        },
        totalFds() {
            return this.data.characterized + this.data.notCaracterizedWithCumply
        },
        reviewedPercentage() {
            return this.totalFds > 0
                ? ((this.chartData.fdsWithReviewed / (this.chartData.fdsWithReviewed + this.chartData.fdsNotReviewed)) * 100).toFixed(0)
                : 0;
        },
        notReviewedPercentage() {
            return this.totalFds > 0
                ? ((this.chartData.fdsNotReviewed / (this.chartData.fdsWithReviewed + this.chartData.fdsNotReviewed)) * 100).toFixed(0)
                : 0;
        },
        reviewedStyle() {
            return { width: this.reviewedPercentage + '%' };
        },
        notReviewedStyle() {
            return { width: this.notReviewedPercentage + '%' };
        }
    },
    mounted() {
        this.initChart()
        window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
        if (this.chart) {
            this.chart.dispose()
        }
        window.removeEventListener('resize', this.handleResize)
    },
    watch: {
        data: {
            deep: true,
            handler() {
                this.updateChart()
            }
        }
    },
    methods: {
        ...mapActions("dashboard", ["findDataProductsByCompanyAndSegment"]),
        ...mapMutations("dashboard", ["resetProductsDashAffected"]),
        initChart() {
            if (this.chart) {
                this.chart.dispose()
            }
            this.chart = echarts.init(this.$refs.chart, null, {
                renderer: 'svg'
            })
            this.updateChart(),
                this.chart.on('click', async (params) => {
                    try {
                        await this.fetchProducts(params)
                    } finally {
                    }
                });
        },
        updateChart() {
            if (this.chart) {
                this.chart.setOption(this.chartOption)
            }
        },
        handleResize() {
            if (this.chart) {
                this.chart.resize()
            }
        },
        async fetchProducts(params) {
            this.localLoading = true
            const payload = {
                segment: params.data.key,
                ...this.dashboardFilters
            }
            await this.findDataProductsByCompanyAndSegment(payload)
            this.modalTitle = params.data.title
            this.keyProducts = params.data.key
            this.selectedProducts = this.productsDashAffected
            this.localLoading = false
            this.$bvModal.show('products-modal-legislation');
        }
    }
}
</script>

<style scoped>

.chart-header {
    display: flex;
    align-items: center;
    margin-bottom: 0.75rem;
}

.chart-title {
    position: relative;
    margin-bottom: 0;
    font-size: 18px;
    font-weight: 800;
    color: #1B212E;
    z-index: 1;
}

.legislation-chart {
    font-family: 'Poppins', sans-serif;
}

.chart-container {
    height: auto;
    width: 100%;
    position: relative;
    margin: 0 auto;
    max-width: 800px;
}

.card {
    border: 1px solid #e2e8f0;
    border-radius: 25px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    background-color: #fff;
}

.card-body {
    padding: 1rem;
}

h4 {
    font-size: 1.5rem;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 0.5rem;
}

.text-muted {
    color: #6c757d;
    font-size: 0.9rem;
}

.status-item {
    padding: 1rem;
    margin-bottom: 1rem;
    border-radius: 12px;
}

.success-item {
    background-color: rgba(40, 167, 69, 0.1);
}

.warning-item {
    background-color: #F279331F;
}

.danger-item {
    background-color: #E9443225;
}

.status-header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.status-text {
    font-weight: 500;
    color: #1a1a1a;
    flex-grow: 1;
}

.dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    flex-shrink: 0;
}

.dot-small {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
}

.fds-progress {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin: 0.75rem 0;
}

.fds-label {
    font-weight: 500;
    color: #495057;
    min-width: 45px;
}

.progress {
    flex-grow: 1;
    height: 24px;
    background-color: rgba(233, 236, 239, 0.5);
    border-radius: 6px;
    overflow: hidden;
}

.progress-bar {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.875rem;
    font-weight: 500;
    color: white;
    transition: width 0.3s ease;
}

.bg-fds {
    background-color: #35C895;
}

.status-details {
    margin-top: 1rem;
}

.detail-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
    color: #495057;
}

.bg-success {
    background-color: #35C895;
}

.bg-success1 {
    background-color: #22956D;
}

.bg-warning-1 {
    background-color: #F27833;
}

.bg-danger-1 {
    background-color: #E94432;
}

.fa-info-circle {
    font-size: 14px;
    color: #6c757d;
    cursor: pointer;
}

.chart-title {
    position: relative;
    margin-bottom: 0;
    font-size: 18px;
    font-weight: 800;
    color: #1B212E;
    z-index: 1;
}

/* Media queries para asegurar la visibilidad en pantallas pequeñas */
@media (max-width: 768px) {
    .chart-container {
        height: 400px;
    }

    .card-body {
        padding: 1rem;
    }

    /* Ajustes específicos para el gráfico en móviles */
    :deep(.echarts-container) {
        margin: 0 -1rem;
        /* Compensar el padding del card-body */
    }
}

.spinner {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.spinner-border {
    width: 1.2rem;
    height: 1.2rem;
    border-width: 0.15em;
}

.chart-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
    transition: opacity 0.3s ease;
    border-radius: 25px;
}

.chart-loading {
    opacity: 0.6;
    pointer-events: none;
    transition: opacity 0.3s ease;
}

.info-btn {
    width: 32px;
    height: 32px;
    padding: 0;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid #e2e8f0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
}

.info-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    background: white;
}

.info-btn i {
    color: #4a5568;
    font-size: 1.1rem;
    transition: color 0.3s ease;
}

.info-btn:hover i {
    color: #2d3748;
}
</style>
